import { A4_WIDTH_72DPI } from "components/DocumentViewer/constants";

const EMPTY = [];
const NO_ROWS = {};
const PAGE_1 = 1;

export const selectDocumentParagraphs = (state) =>
  state?.documentViewer?.general?.documentParagraphs || EMPTY;

export const selectDocumentBaseWidth = (state) =>
  state?.documentViewer?.general?.baseWidth || A4_WIDTH_72DPI;

export const selectCurrentPage = (state) =>
  state?.documentViewer?.general?.currentPage || PAGE_1;

export const selectIsPanelOpen = (state) =>
  Boolean(state?.documentViewer?.general?.isPanelOpen);

export const selectPageIntros = (state) =>
  state?.documentViewer?.general?.pageIntros || EMPTY;

export const selectParagraphRows = (state) =>
  state?.documentViewer?.general?.paragraphRows || NO_ROWS;

export const selectTotalPages = (state) =>
  state?.documentViewer?.general?.totalPages || PAGE_1;

export const selectDocumentZoom = (state) =>
  state?.documentViewer?.general?.zoom || PAGE_1;
